export const roomIsRecording = {
  type: "boolean"
};
